import React from 'react';
import { AlertTriangle, LogOut, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../contexts/AuthContext';

export const SubscriptionExpired = () => {
  const { logout, currentOffice, user } = useAuth();

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center bg-slate-950 p-6"
      data-testid="subscription-expired-screen"
    >
      <div className="max-w-lg w-full bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-800 overflow-hidden">
        <div className="bg-gradient-to-r from-red-600 to-rose-500 px-8 py-6 flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center shrink-0">
            <AlertTriangle className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-white">Access Suspended</h1>
            <p className="text-white/80 text-sm">Your subscription has expired</p>
          </div>
        </div>

        <div className="px-8 py-7 space-y-5">
          <p className="text-slate-700 dark:text-slate-300 text-sm leading-relaxed">
            {currentOffice?.name ? (
              <>Access to <span className="font-semibold">{currentOffice.name}</span> has been suspended because the payment grace period has passed.</>
            ) : (
              <>Access to your workspace has been suspended because the payment grace period has passed.</>
            )}
          </p>

          <div className="rounded-lg bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-900 px-4 py-3">
            <p className="text-sm text-amber-800 dark:text-amber-300">
              Please settle the outstanding invoice to restore full access. Once payment is confirmed by your administrator, access will be reinstated automatically.
            </p>
          </div>

          <div className="space-y-2 text-sm text-slate-600 dark:text-slate-400">
            <p className="font-medium text-slate-800 dark:text-slate-200">Need help?</p>
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4" /> Contact your platform administrator
            </div>
            <div className="flex items-center gap-2">
              <Phone className="h-4 w-4" /> Reach out to billing support to renew
            </div>
          </div>

          <Button
            onClick={logout}
            variant="outline"
            className="w-full flex items-center justify-center gap-2"
            data-testid="subscription-expired-logout-button"
          >
            <LogOut className="h-4 w-4" />
            Log Out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpired;
